import moment from "moment";

import { Badge, CopyButton, CurrencyDisplay } from "../../components";
import { appConfig } from "../../configs";
import {
  IViewTransactionListItem,
  StatusColors,
} from "../../interfaces-and-types";
import {
  getPaymentStatusIndicator,
  truncateStringWithEllipsis,
} from "../../utils";
import { transactionStatus } from "../../enums";
import { ReactNode } from "react";

export const paymentDisplayFormatter = (
  item: IViewTransactionListItem & {
    actions?: ReactNode;
  }
) => {
  const statusIndicator: { statusText: string; statusType: StatusColors } =
    getPaymentStatusIndicator(item);

  return {
    ...item,
    reference: (
      <div className="flex-container justify-content--start align-items--center no-wrap">
        <div className="transaction-id-text modal-header--title">
          <span title={item.tx_ref}>
            {truncateStringWithEllipsis(item.tx_ref, 12)}
          </span>
        </div>
        <div className="copy-button--container ml-3">
          <CopyButton
            name="copy-reference-button"
            stringToCopy={item.tx_ref}
            iconDescription="copy reference"
            className="copy-btn"
          />
        </div>
      </div>
    ),
    amount: (
      <CurrencyDisplay
        currencyOrSymbol={item.currency}
        amount={item.amount}
        title={item.description}
      />
    ),
    amount_paid: (
      <CurrencyDisplay
        currencyOrSymbol={item.currency}
        amount={item.partial_payments_total ?? item.amount_paid}
        title={item.description}
      />
    ),
    status: (
      <Badge
        text={statusIndicator.statusText}
        statusColor={statusIndicator.statusType}
      />
    ),
    description: <strong>{item.description || "..."}</strong>,
    customer: (
      <div className="flex-container justify-content--start align-items--center no-wrap">
        <div className="transaction-id-text modal-header--title">
          <span title={item.customer.email}>
            {item.customer.email || "(anonymous)"}
          </span>
        </div>
        <div className="copy-button--container ml-3">
          <CopyButton
            // name="copy-customer-button"
            stringToCopy={item.customer.email}
            iconDescription="copy customer email"
            className="copy-btn"
          />
        </div>
      </div>
    ),
    gateway: !item.gateway_code ? (
      "-"
    ) : (
      <img
        // src={`${process.env.PUBLIC_URL}/${item.gateway_logo_url}`}
        src={`${process.env.PUBLIC_URL}/gateway-logos/${item.gateway_code}.svg`}
        alt="gateway logo"
        className="gateway-logo-full"
        title={item.gateway_code}
      />
    ),
    date: (
      <span className="date--oneline">
        {moment(
          item.status === transactionStatus.successful ||
            item.status === transactionStatus.partial
            ? item.paid_at
            : item.created_at
        ).format(appConfig.dateTimeFormat)}
      </span>
    ),
    actions: item.actions,
    // more: <OverflowMenuDropDown />,
  };
};
